import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */
export const { Types, Creators } = createActions({
  requestCallNextTicket: [],
  fetchedTicket: [],
  unattachTicket: [],
  requestCancelTicket: [],
  requestCallTicket: [],
  successCallTicket: [],
  requestStartAttendance: [],
  successStartAttendance: [],
  requestDoneAttendance: [],
  successDoneAttendance: [],
  requestSaveTicketDescription: [],
  successSaveTicketDescription: [],
  requestSaveCustomer: [],
  attachCustomer: [],
  requestChangeTicketRating: [],
  requestFindTicketById: [],
});

/* Reducer handlers */

const INITIAL_STATE = Immutable({
  id: 0,
  calledTimes: 1,
  customer: {
    id: 0,
    name: '',
    category: '',
    notes: '',
    priority: 0,
  },
  description: '',
  emissionTimestamp: '00/00/0000 00:00:00',
  evolutionTimestamp: '00/00/0000 00:00:00',
  label: '',
  line: {
    id: 0,
    name: '',
    descriptionOnPanel: '',
    color: '',
    callTimes: 2,
    callIntervals: 10
  },
  ratingId: null,
  ratingColor: null,
  ratingName: null,
  status: -1,
  statusDescription: '',
  startTime: '',
  workstation: {
    id: 0,
    number: 0,
    name: ''
  },
  ticketInformation: null,
});

const fetchedTicket = (state = INITIAL_STATE, action) =>
  ({ ...state, ...action.payload });

const unattachTicket = () => ({ ...INITIAL_STATE });

const successCallTicket = (state = INITIAL_STATE) => (
  {
    ...state,
    calledTimes: state.calledTimes + 1,
    status: 1,
    statusDescription: 'Chamando'
  }
);

const successStartAttendance = (state = INITIAL_STATE) =>
  ({
    ...state,
    status: 2,
    statusDescription: 'Em atendimento'
  });

const successDoneAttendance = () => ({ ...INITIAL_STATE });

const successSaveTicketDescription = (state = INITIAL_STATE, action) =>
  ({ ...state, description: action.payload });

const attachCustomer = (state = INITIAL_STATE, action) =>
  ({ ...state, customer: action.payload });

export default createReducer(INITIAL_STATE, {
  [Types.FETCHED_TICKET]: fetchedTicket,
  [Types.UNATTACH_TICKET]: unattachTicket,
  [Types.SUCCESS_CALL_TICKET]: successCallTicket,
  [Types.SUCCESS_START_ATTENDANCE]: successStartAttendance,
  [Types.SUCCESS_DONE_ATTENDANCE]: successDoneAttendance,
  [Types.SUCCESS_SAVE_TICKET_DESCRIPTION]: successSaveTicketDescription,
  [Types.ATTACH_CUSTOMER]: attachCustomer,
});
